"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
var base_gateway_service_request_1 = require("./../../../services/gateway-control/services/base-gateway-service-request");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted get operations request.
 */
var GatewayServiceGetOperationsRequest = /** @class */ (function (_super) {
    __extends(GatewayServiceGetOperationsRequest, _super);
    /**
     * Create a new GatewayServiceGetOperationsRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param serviceId  the targeted service id
     */
    function GatewayServiceGetOperationsRequest(sessionId, serviceId) {
        var _this = _super.call(this, sessionId, serviceId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.GET_SERVICE_OPERATIONS;
        return _this;
    }
    return GatewayServiceGetOperationsRequest;
}(base_gateway_service_request_1.BaseGatewayServiceRequest));
exports.GatewayServiceGetOperationsRequest = GatewayServiceGetOperationsRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-get-operations-request.js
// module id = 1393
// module chunks = 0